module.exports = __webpack_public_path__ + "img/yuan.7794d522.png";